import { Provider } from 'react-redux';
import { AppProps } from 'next/app';
import appWithI18n from 'next-translate/appWithI18n';
import { FunctionComponent } from 'react';
import { withUnleashProvider } from 'next-unleash';
import configureStore from '../store/config';
import i18nConfig from '../../i18n';
import 'intl-pluralrules';
import ErrorBoundary from '../themes/shared/components/ErrorBoundary';
import '../styles/cosmos.scss';

const store = configureStore();

interface ICustomAppProps extends AppProps {
  err?: unknown;
}

const App = ({ Component, pageProps, err }: ICustomAppProps) => {
  return (
    <ErrorBoundary>
      <Provider store={store}>
        <Component {...pageProps} err={err} />
      </Provider>
    </ErrorBoundary>
  );
};

export default appWithI18n(withUnleashProvider(App) as FunctionComponent, {
  ...i18nConfig,
  // Set to false if you want to load all the namespaces on _app.js getInitialProps
  skipInitialProps: false,
});
